import { specials } from "@/mocks/chigua";

export default function Specials() {
  return (
    <section id="special" className="container-page py-12 md:py-16">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
            <i className="ri-newspaper-line"></i>
            SPECIAL FEATURES
          </p>
          <h2 className="section-title mt-3">专题盘点聚焦</h2>
          <p className="mt-2 text-sm text-foreground-600">
            不止于热榜，吃瓜日报深挖现象背后的逻辑，用连载专题把来龙去脉讲清楚，属于必看用户的深度栏目。
          </p>
        </div>
        <span className="hidden items-center gap-1.5 text-sm text-foreground-500 md:flex">
          <i className="ri-archive-line text-accent-600"></i>
          已连载 {specials.length} 个系列
        </span>
      </div>

      <div className="mt-8 space-y-6">
        {specials.map((s) => (
          <article
            key={s.no}
            className="grid grid-cols-1 overflow-hidden rounded-2xl border border-background-200 bg-background-100 shadow-lift md:grid-cols-12"
          >
            <div className={`relative md:col-span-5 ${s.no === "S02" ? "" : ""}`}>
              <img src={s.image} alt={s.tag + "专题封面"} className="h-56 w-full object-cover md:h-full md:min-h-[260px]" />
              <span className="absolute left-4 top-4 flex h-11 w-11 items-center justify-center rounded-md bg-primary-500/95 font-display text-sm font-black text-background-50">
                {s.no}
              </span>
            </div>
            <div className="flex flex-col justify-center p-5 md:col-span-7 md:p-8">
              <div className="flex flex-wrap items-center gap-2 text-xs">
                <span className="label-cat bg-accent-100 text-accent-800">{s.series}</span>
                <span className="label-cat bg-secondary-100 text-secondary-900">{s.tag}</span>
              </div>
              <h3 className="mt-3 font-display text-xl font-bold leading-snug text-foreground-900 md:text-2xl">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{s.summary}</p>
              <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <span className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-time-line text-accent-600"></i>
                  {s.episode}
                </span>
                <a href="#newsletter" className="inline-flex w-fit items-center gap-1.5 text-sm font-semibold text-primary-600 transition hover:text-primary-700">
                  进入专题系列 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}